import React, { useState, useEffect } from 'react';
import NavBar from '../components/NavBar';
import { Outlet, useLocation } from "react-router-dom";
import './CSS/PageCss.css';
import Hamburger from 'hamburger-react'
import { isMobile } from 'react-device-detect';
import MetaTags from '../util/MetaTags';


const BasePage = () => {

  const [displayBar, setDisplayBar] = useState(!isMobile);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const path = location.pathname.replace('/', '');
    setCurrentPage(path === '' ? 'home' : path);
  }, [location.pathname]);

  const [pageTitle, setPageTitle] = useState('Paul Bekaert Software Engineer and Consultant');
  const [pageDescription, setPageDescription] = useState("Welcome to my professional website. I'm Paul Bekaert, a software engineer and consultant building financial systems, full-stack products, and AI tooling.");

  useEffect(() => {

    if (location.pathname === '/tutoring') {
      setPageTitle('Tutoring with Paul Bekaert');
      setPageDescription('Learn about Paul Bekaert\'s Computer Science and internship coaching! On this page you will find descriptions, reviews, and links to other sites.')
    } else if (location.pathname === '/projects') {
      setPageTitle('Paul Bekaert Projects');
      setPageDescription('Here you can find some of my most interesting projects, which each posed different types of challenges that needed to be overcome.');
    } else if (location.pathname === '/contact') {
      setPageTitle('Contact Paul Bekaert');
      setPageDescription('Please get in touch with me using this form. Your data will remain anonymous and I will aim to answer as fast as I can.');
    } else {
      setPageTitle('Paul Bekaert Software Engineer and Consultant');
      setPageDescription("Welcome to my professional website. I'm Paul Bekaert, a software engineer and consultant building financial systems, full-stack products, and AI tooling.");
    }
  }, [location.pathname]);

  return (
    <div className="container-fluid main-container">
      <div className="row flex-nowrap">
        {displayBar && <NavBar setDisplay={setDisplayBar} currentPage={currentPage} />}
        <div className={displayBar ? "pageContentWithSidebar": "pageContentNoSidebar"} style={{"height" : "100%"}}>
          {isMobile ?
          <div style={{"position":"fixed", "margin-top":"1em", "zIndex":"99"}}><Hamburger toggled={displayBar} toggle={setDisplayBar} aria-label="sidebar open button" /></div>:
          <></>}
          <MetaTags title={pageTitle} description={pageDescription} />
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default BasePage;
